import { useTranslation } from 'react-i18next';
import { Navigate, useParams } from 'react-router-dom';

import { AnimatedRoutedDrawer } from 'src/Components/Drawers/AnimatedRoutedDrawer';
import { InstructionEditionFormWrapper } from 'src/Components/Forms/Instruction/InstructionEditionFormWrapper';

type InstructionParams = {
  instructionId: string;
};

const EditInstructionDrawer = () => {
  const { t } = useTranslation();
  const { instructionId } = useParams<InstructionParams>();

  if (!instructionId) {
    return <Navigate to="/" replace />;
  }

  return (
    <AnimatedRoutedDrawer title={t('editInstructionForm.editInstruction', 'Modifier la consigne')}>
      {({ onClose }) => (
        <InstructionEditionFormWrapper
          onCreate={onClose}
          onCancel={onClose}
          instructionId={instructionId}
        />
      )}
    </AnimatedRoutedDrawer>
  );
};

export default EditInstructionDrawer;
